import { defineComponent as _defineComponent } from 'vue'
import { ref,nextTick,onMounted } from 'vue'

import { TUIGlobal, TUIStore, StoreName, TUIConversationService, TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import {
  TUIChat,
  TUIConversation,
  TUISearch,
  TUIContact,
} from "../TUIKit";
import { TUILogin } from "@tencentcloud/tui-core";




import router from "../router/index";

import { genTestUserSig } from "../TUIKit";
import { SDKAppID, secretKey } from "../main";
//import { ref } from "../TUIKit/adapter-vue";

import Header from "../components/Header.vue";

import MyProfile from './Profile.vue'

import useRoute from "../router/index";

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  emits: ["handleSwitchConversation"],
  setup(__props, { emit: emits }) {


 const currentTab = ref("message");
const currentConversationID = ref("");
const showShibai = ref("");



if(useRoute.app._route.query.userId){
  const options = genTestUserSig({
    SDKAppID,
    secretKey,
    userID: useRoute.app._route.query.userId,
  });
  const loginInfo = {
    SDKAppID,
    userID: useRoute.app._route.query.userId,
    userSig: options.userSig,
    useUploadPlugin: true,
    useProfanityFilterPlugin: true
  };
    
  TUILogin.login(loginInfo)
    .then((res: any) => {
   
          if(useRoute.app._route.query.touser){
            const conversationID = 'C2C' + useRoute.app._route.query.touser;
                    TUIConversationService.getConversationProfile(conversationID)
                    .then((res: any) => {
                      TUIConversationService.switchConversation(
                        res.data.conversation.conversationID
                      );
                      emits("handleSwitchConversation", res.data.conversation.conversationID);
                    })
                    .catch((err: any) => {
                      console.warn("打开会话失败", err.code, err.msg);
                      showShibai.value=err.msg
                    });
          }
                  




    })
    .catch((error: any) => {
      console.warn("打开会话失败", error);
    });
   
}


TUIStore.watch(StoreName.CONV, {
  currentConversationID: (id: string) => {
    currentConversationID.value = id;
  },
});




const selectModel = (modelName: string) => {
  currentTab.value = modelName;
};

const closeChat = (closedConversationID: string) => {
  console.log(`conversation ${closedConversationID} has been closed.`);
};





const exitLogin = () => {
  TUILogin.logout().then(() => {
    router.push({ path: "/" });
  });
}

return { __sfc: true,currentTab, currentConversationID, showShibai, emits, selectModel, closeChat, exitLogin, TUITranslateService, TUIChat, TUIConversation, TUISearch, TUIContact, MyProfile }
}

})